import React, { useState } from 'react';
import { DatePicker, DatePickerInput } from 'carbon-components-react';
import moment from 'moment';
const CustomDateInput = props => {
  const [value, setValue] = useState(props.formData);
  let label = props.schema.title;

  if (props.required) label += ' *';

  const onChange = event => {
    if (Array.isArray(event)) {
      setValue(moment(new Date(event[0])).format('DD/MM/YYYY'));
      props.onChange(moment(new Date(event[0])).format('DD/MM/YYYY'));
    } else {
      // Check if format is correct
      if (moment(event, 'DD-MM-YY')) {
        setValue(event);
        props.onChange(event);
      } else {
      }
    }
  };

  return (
    <div style={{ marginTop: 25 }}>
      <DatePicker
        id={props.idSchema.$id}
        dateFormat='d/m/Y'
        datePickerType='single'
        locale='es'
        onChange={onChange}
        onClose={(data, event) => onChange(event)}
        disabled={props.schema.readOnly}
      >
        <DatePickerInput
          id={props.idSchema.$id}
          type='text'
          labelText={label}
          value={value}
          placeholder='dd/mm/yyyy'
          style={{ background: 'white', width: '100%', minWidth: '200px' }}
          disabled={props.schema.readOnly}
        />
      </DatePicker>
    </div>
  );
};

export default CustomDateInput;
